export default __webpack_public_path__ + "static/media/roadmap.8b3f205a.png";